import React from 'react';
import { setColumnWidth, setNumberWithComma, setDash } from '../../../../../lib/common';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import { PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';
import Anchor from '../../../../../components/link/Anchor';

/**
 *  상품 공지사항에 등록된 아이템 공통 컬럼
 */
export const columns = (data) => {
  const { list, getProductSubCategoryList } = data;
  return [
    {
      accessor: 'url',
      Header: '이미지',
      fixed: 'left',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'productId',
      Header: '상품번호',
      fixed: 'left',
      width: 100,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
    },
    {
      accessor: 'number',
      Header: '제품번호',
      width: setColumnWidth(list, 'number'),
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      width: setColumnWidth(list, 'mainCategory') + 40,
    },
    {
      accessor: 'isSubCategoryExists',
      Header: '2차 카테고리',
      width: 120,
      Cell: (row) =>
        row.value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: row.original.productId,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'productStatus',
      Header: '판매상태',
      Cell: (row) => PRODUCT_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'originPrice',
      Header: '판매가',
      width: 100,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountPrice',
      Header: '할인가',
      width: 100,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountRate',
      Header: '할인율',
      minWidth: 120,
      Cell: (row) => setNumberWithComma(row.value, '%'),
    },
    {
      accessor: 'discountedPrice',
      Header: '할인된 판매가',
      width: 100,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'salesPrice',
      Header: '실판매가',
      width: 100,
      Cell: (row) => setNumberWithComma(row.value),
    },
  ];
};
